import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	Box,
	Card,
	CardActions,
	CardContent,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	MenuItem,
	Select,
	TextField,
	IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { updateInsertAgent } from "../../actions/agent";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "50px",
	width: "200px",
	textTransform: "capitalize",
	marginLeft: 2,
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const AddUpdateAgent = ({ token, addUpdateAgentDialog, setAddUpdateAgentDialog, agent, setAgent, agents, merchants, edit, setEdit }) => {
	const [disabled, setDisabled] = useState(false);
	const handleChangeMerchant = (e) => {
		setAgent({ ...agent, merchantId: e.target.value.toString() });
	};

	const handleChangeParent = (e) => {
		setAgent({ ...agent, masterId: e.target.value.toString() });
	};

	const handleChangeAgentCommission = (e) => {
		setAgent({ ...agent, agentCommissionId: e.target.value.toString() });
	};

	const handleChangeAgentTransfer = (e) => {
		setAgent({ ...agent, agentTransferId: e.target.value.toString() });
	};

	const changeActive = (e) => {
		e.preventDefault();
		setAgent({ ...agent, active: e.target.checked });
	};

	const cancelAction = (e) => {
		e.preventDefault();
		setAgent({});
		setEdit(false);
		setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: false });
	};

	const saveUpdateAction = (e) => {
		e.preventDefault();
		setDisabled(true);
		updateInsertAgent(token, agent, edit, (res) => {
			console.log("Insert res", res);
			if (!res.error) {
				if (!edit) {
					toast.success("Agent created.", { position: "top-center", duration: 2000 });
					setTimeout(() => {
						setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: false });
						setAgent({});
						setEdit(false);
						setDisabled(false);
					}, 2000);
				} else {
					toast.success("Agent updated.", { position: "top-center", duration: 2000 });
					setTimeout(() => {
						setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: false });
						setAgent({});
						setEdit(false);
						setDisabled(false);
					}, 2000);
				}
			} else {
				toast.error(res.message, { position: "top-center", duration: 7000 });
				setDisabled(false);
			}
		});
	};

	const handleClose = (e) => {
		e.preventDefault();
		setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: false });
	};

	return (
		<Dialog open={addUpdateAgentDialog.isOpen} onClose={handleClose}>
			<DialogTitle>
				<Typography component="h2" variant="subtitle1" gutterBottom>
					{addUpdateAgentDialog.title}
				</Typography>
			</DialogTitle>
			<IconButton
				aria-label="close"
				onClick={handleClose}
				sx={(theme) => ({
					position: "absolute",
					right: 8,
					top: 8,
				})}
			>
				<CloseIcon />
			</IconButton>
			<DialogContent>
				<Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ mt: 3 }}>
					<Card sx={{ width: "100%" }}>
						<CardContent>
							<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
								{`Agent Configuration ${agent.agent ?? ""}`}
							</Typography>
							<FormControlLabel
								control={<Checkbox checked={agent.active ?? false} onChange={changeActive} />}
								label="Active"
								id="activeAgent"
							/>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Parent Agent
									</Typography>
								</Box>
								<Select
									size="medium"
									value={agent.masterId ?? "first"}
									onChange={handleChangeParent}
									sx={{ borderRadius: 6, display: "flex" }}
									fullWidth
								>
									<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
										<Box sx={{ display: "flex" }}>
											<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
												{"Select Parent Agent"}
											</Typography>
										</Box>
									</MenuItem>
									{agents?.map((ag) => {
										if (ag.id?.toString() !== agent.id?.toString()) {
											return (
												<MenuItem value={ag.id.toString()} key={ag.id} component="div" style={{ display: "flex" }}>
													<Box sx={{ display: "flex" }}>
														<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
															{ag.agent}
														</Typography>
													</Box>
												</MenuItem>
											);
										}
									})}
								</Select>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Merchant
									</Typography>
								</Box>
								<Select
									size="medium"
									value={agent.merchantId?.toString() ?? "first"}
									onChange={handleChangeMerchant}
									sx={{ borderRadius: 6, display: "flex" }}
									fullWidth
								>
									<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
										<Box sx={{ display: "flex" }}>
											<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
												{"Select Merchant"}
											</Typography>
										</Box>
									</MenuItem>
									{merchants?.map((mer) => {
										return (
											<MenuItem value={mer.id.toString()} selected key={mer.id} component="div" style={{ display: "flex" }}>
												<Box sx={{ display: "flex" }}>
													<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
														{mer.name}
													</Typography>
												</Box>
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										External Id
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.agent ?? ""}
									type="text"
									onChange={(e) => {
										setAgent({ ...agent, agent: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Username
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.username ?? ""}
									type="text"
									onChange={(e) => {
										setAgent({ ...agent, username: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Password
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.password ?? ""}
									type="password"
									onChange={(e) => {
										setAgent({ ...agent, password: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Agent Commission
									</Typography>
								</Box>
								<Select
									size="medium"
									value={agent.agentCommissionId?.toString() ?? "first"}
									onChange={handleChangeAgentCommission}
									sx={{ borderRadius: 6, display: "flex" }}
									fullWidth
								>
									<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
										<Box sx={{ display: "flex" }}>
											<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
												{"Select Commission Agent"}
											</Typography>
										</Box>
									</MenuItem>
									{agents?.map((ag) => {
										if (ag.id?.toString() !== agent.id?.toString()) {
											return (
												<MenuItem value={ag.id.toString()} key={ag.id} component="div" style={{ display: "flex" }}>
													<Box sx={{ display: "flex" }}>
														<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
															{ag.agent}
														</Typography>
													</Box>
												</MenuItem>
											);
										}
									})}
								</Select>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Agent Commission Fee
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.agentCommissionFee ?? ""}
									type="number"
									onChange={(e) => {
										setAgent({ ...agent, agentCommissionFee: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Agent Transfer
									</Typography>
								</Box>
								<Select
									size="medium"
									value={agent.agentTransferId?.toString() ?? "first"}
									onChange={handleChangeAgentTransfer}
									sx={{ borderRadius: 6, display: "flex" }}
									fullWidth
								>
									<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
										<Box sx={{ display: "flex" }}>
											<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
												{"Select Agent Transfer"}
											</Typography>
										</Box>
									</MenuItem>
									{agents?.map((ag) => {
										if (ag.id?.toString() !== agent.id?.toString()) {
											return (
												<MenuItem value={ag.id.toString()} key={ag.id} component="div" style={{ display: "flex" }}>
													<Box sx={{ display: "flex" }}>
														<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
															{ag.agent}
														</Typography>
													</Box>
												</MenuItem>
											);
										}
									})}
								</Select>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Transfer Fee
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.agentTransferFee ?? ""}
									type="number"
									onChange={(e) => {
										setAgent({ ...agent, agentTransferFee: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Agent Deposit Fee
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.feeDepositAgent ?? ""}
									type="number"
									onChange={(e) => {
										setAgent({ ...agent, feeDepositAgent: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Agent Automatic Withdrawal Amount
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.agentAutomaticWithdrawalAmount ?? ""}
									type="number"
									onChange={(e) => {
										setAgent({ ...agent, agentAutomaticWithdrawalAmount: e.target.value });
									}}
								></TextField>
							</FormControl>
							<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
								<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
									<Typography component="h2" variant="subtitle2" gutterBottom>
										Telegram Id
									</Typography>
								</Box>
								<TextField
									fullWidth
									defaultValue={agent.telegram ?? ""}
									type="number"
									onChange={(e) => {
										setAgent({ ...agent, telegram: e.target.value });
									}}
								></TextField>
							</FormControl>
						</CardContent>
						<CardActions>
							<Box
								sx={{
									alignItems: "center",
									alignContent: "center",
									textAlign: "center",
									width: "100%",
									paddingBottom: 4,
									paddingTop: 2,
								}}
							>
								<Button size="small" variant="extended" sx={styleButton} onClick={cancelAction} disabled={disabled}>
									{"CANCEL"}
								</Button>
								<Button size="small" variant="extended" sx={styleButton} onClick={saveUpdateAction} disabled={disabled}>
									{edit ? "SAVE" : "INSERT"}
								</Button>
							</Box>
						</CardActions>
					</Card>
					<Toaster />
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default AddUpdateAgent;
